// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__v6nOF","signatureButtonsRight":"ModalSign_signatureButtonsRight__1cSjD"};